import { render, staticRenderFns } from "./OrderComplete.vue?vue&type=template&id=47f22aa6&scoped=true"
import script from "./OrderComplete.vue?vue&type=script&lang=js"
export * from "./OrderComplete.vue?vue&type=script&lang=js"
import style0 from "./OrderComplete.vue?vue&type=style&index=0&id=47f22aa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f22aa6",
  null
  
)

export default component.exports